export interface FakeOffer {
  id: string
  price: string
  minDays: number
  maxDays: number
  sellerName: string
  rating: string
  isSelected: boolean
}

export const FAKE_OFFERS: FakeOffer[] = [
  {
    id: 'offer-1',
    price: '$420.00',
    minDays: 2,
    maxDays: 3,
    sellerName: 'EndFastTech LTD',
    rating: '4,3',
    isSelected: false,
  },
  {
    id: 'offer-2',
    price: '$438.00',
    minDays: 1,
    maxDays: 2,
    sellerName: 'Crazy4Usb-c',
    rating: '4,5',
    isSelected: true,
  },
  {
    id: 'offer-3',
    price: '$441.00',
    minDays: 3,
    maxDays: 5,
    sellerName: 'E-waste destroyers',
    rating: '3,9',
    isSelected: false,
  },
]
